import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Switch from "@material-ui/core/Switch";
import { instance } from "Actions/AxiosInstance";
import { CheckActionPermission } from "Actions/commonAction";
import { ChangeLanguage } from "Actions/LanguageAction";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import CallOutNew from "Component/Headers/callOutNew";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { ErrorMessages } from "Constants";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
     
        config: {
          isindepartment: true,
          isdeptshowtime: true,
          isinorganization: false,
          isorgshowtime: false,
          iscaldepartment: true,
          iscalorganization: false,
        },

        postdata:{config:{}}
      
    };

    this.updateconfig = this.updateconfig.bind(this);
    this.onSave = this.onSave.bind(this);
    this.getCommonConfig = this.getCommonConfig.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("commonAccess");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getCommonConfig();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getCommonConfig() {
    instance
      .get("subscription/getcommonconfig")
      .then((result) => {
        this.setState({
          isindepartment:
            result.data.result[0] && result.data.result[0].isindepartment,
          isdeptshowtime:
            result.data.result[0] && result.data.result[0].isdeptshowtime,
          isinorganization:
            result.data.result[0] && result.data.result[0].isinorganization,
          isorgshowtime:
            result.data.result[0] && result.data.result[0].isorgshowtime,
          iscaldepartment:
            result.data.result[0] && result.data.result[0].iscaldepartment,
          iscalorganization:
            result.data.result[0] && result.data.result[0].iscalorganization,
            config:result.data.result[0] ? result.data.result[0] : this.state.config,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onSave() {
    const { config, postdata } = this.state;
    config.isorgshowtime =
      config.isinorganization && config.isorgshowtime
        ? true
        : false;

    config.isdeptshowtime =
      config.isindepartment && config.isdeptshowtime
        ? true
        : false;

    postdata.config = config;
    

    instance
      .post(`subscription/createcommonconfig`, postdata)
      .then(() => {
        this.setState(
          {
            // config: null,
            // selecteddata: null,
          },
          () => {
            this.props.enqueueSnackbar(ErrorMessages.E0000, {
              variant: "success",
            });

            this.getCommonConfig();
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  updateconfig(key, value) {
    const { config } = this.state;
    config[key] = value;
    this.setState({ config });
  }

  render() {
    const { config } = this.state;

    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Config.CustomData.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <Grid container>
              <Grid item xs={12} md={12} sm={12}>
                <p className="large-text-dark t-bold margin-bottom-24">
                  Common Access
                </p>
                <Paper className="rounded-rectangle-paper padding16">
                  <p className="normal-dark t-bold margin-bottom-8">
                    Who's in today
                  </p>
                  <p className="small-dark-secondary margin-bottom-16">
                    How much data would you like the employee & manager* to view
                  </p>
                  <Grid container spacing={2}>
                    <Grid item md={6} sm={12}>
                      <div className="rounded-rectangle-div padding16">
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value: config && config.isindepartment,
                            placeholder: "",
                            label: "Department",
                          })}
                          onChange={(value) => {
                            this.updateconfig("isindepartment", value);
                          }}
                        />
                        {config &&
                          config &&
                          config.isindepartment && (
                            <div
                              className="display-flex"
                              style={{ alignItems: "center", marginTop: -16 }}
                            >
                              <p className="input-label margin-right-8">
                                Show clock-in time for members in the department
                              </p>
                              <div className="expense-limit-switch">
                                <Switch
                                  checked={
                                    config &&
                                    config &&
                                    config.isdeptshowtime
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    this.updateconfig(
                                      "isdeptshowtime",
                                      e.target.value == "true" ? false : true,
                                    )
                                  }
                                  value={
                                    config &&
                                    config &&
                                    config.isdeptshowtime
                                      ? true
                                      : false
                                  }
                                  // name={column}
                                  color="primary"
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </Grid>
                    <Grid item md={6} sm={12}>
                      <div className="rounded-rectangle-div padding16">
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value: config && config.isinorganization,
                            placeholder: "",
                            label: "Organization",
                          })}
                          onChange={(value) => {
                            this.updateconfig("isinorganization", value);
                          }}
                        />
                        {config &&
                          config &&
                          config.isinorganization && (
                            <div
                              className="display-flex"
                              style={{ alignItems: "center", marginTop: -16 }}
                            >
                              <p className="input-label margin-right-8">
                                Show clock-in time for members in the
                                organization
                              </p>
                              <div className="expense-limit-switch">
                                <Switch
                                  checked={
                                    config &&
                                    config &&
                                    config.isorgshowtime &&
                                    config.isinorganization
                                      ? true
                                      : false // !config.isinorganization ? false : false
                                  }
                                  onChange={(e) =>
                                    this.updateconfig(
                                      "isorgshowtime",
                                      e.target.value == "true" ? false : true,
                                    )
                                  }
                                  value={
                                    config &&
                                    config &&
                                    config.isorgshowtime
                                      ? true
                                      : false
                                  }
                                  // name={column}
                                  color="primary"
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12} md={12} sm={12} className="margin-top-24">
                <Paper className="rounded-rectangle-paper padding16">
                  <p className="normal-dark t-bold margin-bottom-8">
                    Calendar's data level
                  </p>
                  <p className="small-dark-secondary margin-bottom-16">
                    How much data would you like the employee & manager* to view
                  </p>
                  <div className="display-flex">
                    <div>
                      <DynamicForm
                        fields={checkboxinputconverter({
                          value: config && config.iscaldepartment,
                          placeholder: "",
                          label: "Department",
                        })}
                        onChange={(value) => {
                          this.updateconfig("iscaldepartment", value);
                        }}
                      />
                    </div>
                    <div className="margin-left-32">
                      <DynamicForm
                        fields={checkboxinputconverter({
                          value: config && config.iscalorganization,
                          placeholder: "",
                          label: "Organization",
                        })}
                        onChange={(value) => {
                          this.updateconfig("iscalorganization", value);
                        }}
                      />
                    </div>
                  </div>
                </Paper>
                <div className="margin-top-24">
                  <CallOutNew
                    classnames="bg-light-blue"
                    header="📌 Managers will always have access to their report's data"
                    emoji=""
                    textcolor="#1e8ced"
                  />
                </div>
              </Grid>
            </Grid>
            <div
              className="width100"
              style={{
                position: "fixed",
                left: 0,
                background: "white",
                bottom: 0,
                padding: 10,
                borderTop: "1px solid #d4d4d4",
                zIndex: 0,
              }}
            >
              <div>
                <div className="floatright" style={{ marginRight: 72 }}>
                  <div>
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      onClick={() => this.onSave()}
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="clearfloat"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  FCMReducer: state.FCMReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(index)),
);
